import { memo } from 'react';
import type { FieldWithLabelAndInputPT } from '@shared/ui/forms/FieldWithLabel/FieldWithLabelAndCard/types';
import { FormFieldWithLabelAndCard } from '@shared/ui/forms/FieldWithLabel/FieldWithLabelAndCard/ui';
import { NumberTextInputM } from '@shared/ui/inputs/TextInputM/NumberTextInputM/ui';

type PT = FieldWithLabelAndInputPT;
export const FormFieldWithLabelAndNumberInput = memo(
  ({ fieldLabel, requiredField, helperText, error, children, className, ...props }: PT) => {
    return (
      <FormFieldWithLabelAndCard
        requiredField={requiredField}
        fieldLabel={fieldLabel}
        helperText={helperText}
        error={error}
        className={className}
      >
        <NumberTextInputM error={error?.message} {...props} />
        {children}
      </FormFieldWithLabelAndCard>
    );
  }
);
